module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0006#abbrev"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0007#ch01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("  Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0008#ch02"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("  The Workers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0009#ch03"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("  The Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0010#ch04"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("  The Workplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0011#ch05"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("  Public-Private Partnerships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0012#ch06"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("  Institutional Boundaries, Accountability, and the Integral State")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0013#ch07"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("  The Politics of Free Labor: Visibility and Invisibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0014#ch08"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("  Valuing Maintenance, Valuing Workers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0015#aft"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0016#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0017#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0018#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiKrinsky0019#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4e34c0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Krinsky-0005.vue
// module id = 66
// module chunks = 0